import { createSvgIcon, SvgIcon } from '@mui/material';
import { ComponentType, createElement } from 'react';
import Approve from './assets/approve.svg';
import Discord from './assets/discord.svg';
import Medium from './assets/medium.svg';
import Telegram from './assets/telegram.svg';
import Twitter from './assets/twitter.svg';

const createMaterialIcon = (Icon: ComponentType): typeof SvgIcon => {
  return createSvgIcon(createElement(Icon), Icon.displayName || 'SVGIcon');
};

export const ApproveIcon = createMaterialIcon(Approve);
export const DiscordIcon = createMaterialIcon(Discord);
export const MediumIcon = createMaterialIcon(Medium);
export const TwitterIcon = createMaterialIcon(Twitter);
export const TelegramIcon = createMaterialIcon(Telegram);